module.exports = __webpack_public_path__ + "static/img/10210.3e53bb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/10210.jpg
// module id = JA+7
// module chunks = 0